import React from 'react'

const NiTransfer = () => {
    return (
        <svg width="24" height="24" class="mb-4 text-text-primary" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 10L3.70711 7.20711C3.31658 6.81658 3.31658 6.18342 3.70711 5.79289L6.5 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path opacity="0.6" d="M4 6.49999L17.5 6.5C19.433 6.5 21 8.067 21 10V10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path d="M17.5 14L20.2929 16.7929C20.6834 17.1834 20.6834 17.8166 20.2929 18.2071L17.5 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path><path opacity="0.6" d="M20 17.5L6.5 17.5C4.567 17.5 3 15.933 3 14V14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>
    )
}

export default NiTransfer
